// extracted by mini-css-extract-plugin
module.exports = {"ocrUploader":"OCRAutofill_ocrUploader__12YOm","uploadPick":"OCRAutofill_uploadPick__12GZM","fetching":"OCRAutofill_fetching__2L6PP","spin":"OCRAutofill_spin__2tq7b"};